export const WS_EVENTS = {
  NOTIFICATION: "notification",
  SYSTEM_NOTIFICATION: "system_notification",
  PAYMENT_STATUS_SUCCESS: "payment_status_success",
  REQUEST_SUBSCRIPTION_STATUS: "request_subscription_status",
  VIDEO_PROGRESS_UPDATE: "video_progress_update",
  NEW_SYSTEM_MESSAGE: "new_system_message",
  ACHIEVEMENT_AWARDED: "achievement_awarded",
  DEVICE_VERIFIED: "device_verified",
} as const;

export type WsEvent = (typeof WS_EVENTS)[keyof typeof WS_EVENTS];
